<h4>
    {{ date | dateTime : venue.timeZone : DateTime.DATE_FULL }}
    @if (serviceDescription) {
        - {{ serviceDescription.name }}
        ({{ serviceDescription.start | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }} -
        {{ serviceDescription.end | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }})
    }
</h4>
<div>
    <table class="table mb-5 pb-5 bookings-print-out">
        <colgroup>
            <col>
            <col>
            <col *ngIf="showPhoneColumn">
            <col>
            <col *ngIf="showReasonColumn">
            <col *ngIf="showDepositColumn">
            <col *ngIf="showDietaryColumn">
            <col *ngIf="showNotesColumn">
            <col>
        </colgroup>
        <thead>
            <tr class="text-uppercase">
                <th scope="col">
                    Time In - Out
                </th>
                <th scope="col">
                    Name
                </th>
                <th
                    *ngIf="showPhoneColumn"
                    scope="col">
                    Phone
                </th>
                <th scope="col">
                    Covers
                </th>
                <th
                    *ngIf="showReasonColumn"
                    scope="col">
                    Reason
                </th>
                <th
                    *ngIf="showDepositColumn"
                    scope="col">
                    Deposit
                </th>
                <th
                    *ngIf="showDietaryColumn"
                    scope="col">
                    Dietary
                </th>
                <th
                    *ngIf="showNotesColumn"
                    scope="col">
                    Notes
                </th>
                <th scope="col">
                    Table
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let entry of bookingsOnTables">
                <td>
                    {{entry.booking.start | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }}
                    -
                    {{entry.booking.end | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }}
                </td>
                <td>{{entry.booking.firstName}} {{entry.booking.lastName}}</td>
                <td *ngIf="showPhoneColumn">{{ entry.booking.phoneNumber | phoneNumber }}</td>
                <td>{{entry.booking.size}}</td>
                <td *ngIf="showReasonColumn">
                    <span
                        *ngIf="entry.reason"
                    >
                        {{entry.reason.displayName}}
                    </span>
                    <span
                        *ngIf="entry.event"
                    >
                        {{entry.event.displayName}}
                    </span>
                </td>
                <td *ngIf="showDepositColumn">
                    {{ getDepositStatus(entry.booking) }}
                </td>
                <td *ngIf="showDietaryColumn">
                    {{ entry.dietaryRestrictions }}
                </td>
                <td *ngIf="showNotesColumn">
                    @if (printType === 'large-parties') {
                        @if (entry.booking.notes && entry.booking.merchantNotes) {
                            <div>
                                <div><strong>Customer:</strong> {{entry.booking.notes}}</div>
                                <hr class="my-1">
                                <div><strong>Staff:</strong> {{entry.booking.merchantNotes}}</div>
                            </div>
                        } @else if (entry.booking.notes) {
                            <div><strong>Customer:</strong> {{entry.booking.notes}}</div>
                        } @else if (entry.booking.merchantNotes) {
                            <div><strong>Staff:</strong> {{entry.booking.merchantNotes}}</div>
                        }
                    } @else {
                        @if (entry.booking.notes && entry.booking.merchantNotes) {
                            <div>
                                <div><strong>Customer:</strong> {{entry.booking.notes | slice:0:90}}
                                    <span *ngIf="entry.booking.notes.length > 90">…</span>
                                </div>
                                <hr class="my-1">
                                <div><strong>Staff:</strong> {{entry.booking.merchantNotes | slice:0:90}}
                                    <span *ngIf="entry.booking.merchantNotes.length > 90">…</span>
                                </div>
                            </div>
                        } @else if (entry.booking.notes) {
                            <div><strong>Customer:</strong> {{entry.booking.notes | slice:0:180}}
                                <span *ngIf="entry.booking.notes.length > 180">…</span>
                            </div>
                        } @else if (entry.booking.merchantNotes) {
                            <div><strong>Staff:</strong> {{entry.booking.merchantNotes | slice:0:180}}
                                <span *ngIf="entry.booking.merchantNotes.length > 180">…</span>
                            </div>
                        }
                    }
                </td>
                <td>{{ entry.booking | tableName: entry.area: 'short' }}</td>
            </tr>
        </tbody>
    </table>
</div>
